import Icon from '../components/Icon.vue'

Icon.register({
  'fire-extinguisher': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M434 26.3c7.3-1.2 14 4.4 14 11.8v115.7c0 7.4-6.7 13.1-14 11.8l-168-28c-11.7-2-10-14.7-10-17.7h-40v27c41.4 10.7 72 48.2 72 93v248c0 13.3-10.7 24-24 24h-144c-13.3 0-24-10.7-24-24v-246.8c0-44.9 30.5-83.3 72-94.1v-27.1c-61 0-92.9-7-121.7 64.9-4.9 12.3-18.9 18.3-31.2 13.4-12.3-4.9-18.3-18.9-13.4-31.2 14.7-36.7 38-77.8 90-90.9-14.1-36.5 12.8-76.2 52.2-76.2 37.4 0 64.4 36.1 53.7 72h58.3c0-4.2-1.3-15.8 10-17.7zM144 72c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z'
      }
    ]
  }
})
